import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class AfterSale {
  /* 售后服务列表 */
  static getAfterSaleList(options) {
    let url = `/oa/api/order/express/collect/project/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 总计 */
  static getAfterSaleStatisticsList(options) {
    let url = `/oa/api/order/express/collect/warehouse/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 未揽收订单数 */
  static getUncollectedOrderNumsList(options) {
    let url = `/oa/api/order/express/collect/warehouse/not/collect?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 揽收单量 */
  static getcollectedOrderNumsList(options) {
    let url = `/oa/api/order/express/collect/collect/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 导出未揽收订单数
  static getExportUncollectedOrderNumsExcel(options) {
    let url = `/oa/api/download/warehouse/not/collect?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default AfterSale